export const convertHtmlToText = (html: string): string => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const paragraphs = Array.from(doc.querySelectorAll('p'))

  const parsedArray = paragraphs.map((paragraph) => {
    const temp = document.createElement('span')
    temp.innerHTML = paragraph.innerHTML.replace(/<\/?tag[^>]*>/g, ' ')
    return temp.innerText
  })

  return parsedArray[1] ?? ''
}
